/* chrome.js: ported from zum-impulse, Alpine components registered on alpine:init.
   Header (sticky / overlay / menus / nav drawer / search), predictive search, localization disclosures,
   announcement bar, tooltip modal, overlay drawer, video modal. */
(function () {
  'use strict';

  var mqSmall = window.matchMedia('(max-width: 767px)');
  // Impulse: a stuck header goes back to static on short, wide screens.
  var mqShort = window.matchMedia('(min-width: 700px) and (max-height: 550px)');

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function throttle(fn, wait) {
    var last = 0;
    return function () {
      var now = Date.now();
      if (now - last < wait) return;
      last = now;
      fn.apply(this, arguments);
    };
  }

  var scrollLocks = 0;
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.documentElement.classList.toggle('overflow-hidden', scrollLocks > 0);
  }

  var FOCUSABLE = 'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), input:not([type=hidden]):enabled, select:enabled, textarea:enabled, iframe';

  // Keeps Tab inside container; returns the release function.
  function trapFocus(container) {
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var els = Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!els.length) return;
      var first = els[0];
      var last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    document.addEventListener('keydown', onKey);
    return function () { document.removeEventListener('keydown', onKey); };
  }

  document.addEventListener('alpine:init', function () {
    /* ===== Header ===== */
    Alpine.data('siteHeader', function (opts) {
      return {
        sticky: !!opts.sticky,
        overlay: !!opts.overlay,
        hoverMenu: !!opts.hoverMenu,
        stuck: false,
        opening: false,
        height: 0,
        forceStopSticky: false,
        navOpen: false,
        searchOpen: false,
        _openTimer: null,

        get light() {
          return this.overlay && !this.stuck;
        },

        init: function () {
          var self = this;

          // Editor only: overlay header on a collection without a hero falls back to the normal header.
          if (this.overlay && designMode() && document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
            this.overlay = false;
          }

          this.initDetails();

          if (this.sticky) {
            this.forceStopSticky = !this.megaMenuFits();
            if (!this.forceStopSticky) {
              this.measure();
              window.addEventListener('resize', debounce(function () { self.measure(); }, 50));
              window.addEventListener('scroll', throttle(function () {
                requestAnimationFrame(function () { self.onScroll(); });
              }, 20), { passive: true });
              if (designMode()) setTimeout(function () { self.measure(); }, 250);
              this.onScroll();
            }
          }
        },

        measure: function () {
          var header = this.$refs.header;
          if (!header) return;
          var h = header.offsetHeight;
          // A stuck header has half the padding on desktop; add it back so the placeholder keeps the full height.
          if (this.stuck && !mqSmall.matches) {
            h += parseFloat(window.getComputedStyle(header).paddingTop) * 2;
          }
          this.height = h;
        },

        onScroll: function () {
          var self = this;
          if (window.scrollY > 250 && !mqShort.matches) {
            if (this.stuck) return;
            this.stuck = true;
            // Transition class after the element is fixed so the slide-down animates.
            clearTimeout(this._openTimer);
            this._openTimer = setTimeout(function () { self.opening = true; }, 100);
          } else {
            if (!this.stuck) return;
            clearTimeout(this._openTimer);
            this.opening = false;
            this.stuck = false;
          }
        },

        // Sticky is disabled when the tallest mega menu does not fit the viewport.
        megaMenuFits: function () {
          var largest = 0;
          var opened = [];
          var menus = this.$el.querySelectorAll('.megamenu');
          menus.forEach(function (nav) {
            var details = nav.closest('details');
            if (details && !details.hasAttribute('open')) {
              details.setAttribute('open', '');
              opened.push(details);
            }
          });
          menus.forEach(function (nav) {
            if (nav.offsetHeight > largest) largest = nav.offsetHeight;
          });
          opened.forEach(function (details) { details.removeAttribute('open'); });
          return window.innerHeight >= largest + 120;
        },

        initDetails: function () {
          var all = Array.prototype.slice.call(this.$el.querySelectorAll('details.site-nav__details'));
          if (!all.length) return;

          function setOpen(detail, on) {
            if (on) detail.setAttribute('open', '');
            else detail.removeAttribute('open');
          }

          all.forEach(function (detail) {
            var summary = detail.querySelector('summary');
            detail.addEventListener('toggle', function () {
              summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
            });
          });

          // Close an open dropdown on any click outside it.
          document.addEventListener('click', function (evt) {
            all.forEach(function (detail) {
              if (detail.open && !detail.contains(evt.target)) setOpen(detail, false);
            });
          });

          var hoverDetails = all.filter(function (d) { return d.dataset.hover === 'true'; });
          hoverDetails.forEach(function (detail) {
            var summary = detail.querySelector('summary');

            summary.addEventListener('click', function (e) {
              e.preventDefault();
              window.location.href = summary.dataset.link;
            });

            detail.addEventListener('focusin', function () {
              if (detail.open) return;
              hoverDetails.forEach(function (d) { setOpen(d, false); });
              setOpen(detail, true);
            });

            detail.addEventListener('focusout', function () {
              setTimeout(function () {
                if (detail.open && !detail.matches(':focus-within')) setOpen(detail, false);
              });
            });

            detail.addEventListener('mouseover', function () {
              if (!detail.open) setOpen(detail, true);
            });

            detail.addEventListener('mouseleave', function () {
              if (detail.open) setOpen(detail, false);
            });
          });
        },

        openSearch: function () {
          this.searchOpen = true;
          this.$dispatch('predictive-search-open', { context: 'header' });
        },

        toggleInert: function (on) {
          var main = document.getElementById('main-content');
          if (main) {
            if (on) main.setAttribute('inert', '');
            else main.removeAttribute('inert');
          }
          if (on !== this._navLocked) {
            if (on || this._navLocked) lockScroll(!!on);
            this._navLocked = !!on;
          }
        }
      };
    });

    /* ===== Predictive search ===== */
    Alpine.data('predictiveSearch', function (opts) {
      return {
        context: opts.context,
        enabled: !!opts.enabled,
        url: opts.url,
        active: false,
        open: false,
        _ctrl: null,

        onOpen: function (detail) {
          var self = this;
          if (!detail || detail.context !== this.context) return;
          this.active = true;
          setTimeout(function () { self.$refs.input.focus(); }, 100);
          this.setLock(true);
        },

        onChange: function () {
          if (!this.enabled) return;
          var term = this.$refs.input.value.trim();
          if (!term.length) return;
          this.getResults(term);
        },

        getResults: function (term) {
          var self = this;
          if (this._ctrl) this._ctrl.abort();
          this._ctrl = new AbortController();
          var params = 'q=' + encodeURIComponent(term) +
            '&resources[limit]=3&resources[limit_scope]=each&resources[options][unavailable_products]=last';

          fetch(this.url + '?' + params + '&section_id=search-results', { signal: this._ctrl.signal })
            .then(function (res) {
              if (!res.ok) throw new Error(res.status);
              return res.text();
            })
            .then(function (text) {
              var doc = new DOMParser().parseFromString(text, 'text/html');
              var section = doc.querySelector('#shopify-section-search-results');
              self.$refs.results.innerHTML = section ? section.innerHTML : '';
              self.open = true;
            })
            .catch(function (err) {
              if (err && err.name === 'AbortError') return;
              self.close();
            });
        },

        setLock: function (on) {
          if (on === !!this._locked) return;
          this._locked = on;
          lockScroll(on);
        },

        close: function () {
          if (this._ctrl) this._ctrl.abort();
          this.open = false;
          this.$refs.results.innerHTML = '';
          this.active = false;
          this.setLock(false);
          window.dispatchEvent(new CustomEvent('predictive-search-close-all'));
        }
      };
    });

    /* ===== Localization disclosure ===== */
    Alpine.data('disclosure', function () {
      return {
        open: false,
        select: function (value) {
          this.$refs.input.value = value;
          this.open = false;
          var form = this.$refs.input.closest('form');
          if (form) form.submit();
        },
        onFocusOut: function (e) {
          if (!this.$root.contains(e.relatedTarget)) this.open = false;
        }
      };
    });

    /* ===== Announcement bar ===== */
    Alpine.data('announcementBar', function (opts) {
      return {
        compact: !!opts.compact,
        count: opts.count || 0,
        sectionId: opts.sectionId,
        index: 0,
        slider: false,
        paused: false,
        _timer: null,
        _x: 0,

        init: function () {
          var self = this;
          var update = function () {
            var s = self.count > 1 && (self.compact || mqSmall.matches);
            if (s !== self.slider) {
              self.slider = s;
              self.index = 0;
            }
            self.restart();
          };
          update();
          mqSmall.addEventListener('change', update);

          // Editor: show and hold the selected block.
          document.addEventListener('shopify:block:select', function (e) {
            if (!e.detail || e.detail.sectionId !== self.sectionId) return;
            var slide = self.$root.querySelector('#AnnouncementSlide-' + e.detail.blockId);
            if (!slide) return;
            self.index = parseInt(slide.dataset.index, 10) || 0;
            self.paused = true;
            self.restart();
          });
          document.addEventListener('shopify:block:deselect', function (e) {
            if (!e.detail || e.detail.sectionId !== self.sectionId) return;
            self.paused = false;
            self.restart();
          });
        },

        restart: function () {
          var self = this;
          clearInterval(this._timer);
          if (!this.slider || this.paused) return;
          this._timer = setInterval(function () { self.next(); }, 5000);
        },

        next: function () {
          this.index = (this.index + 1) % this.count;
        },

        prev: function () {
          this.index = (this.index - 1 + this.count) % this.count;
        },

        togglePause: function () {
          this.paused = !this.paused;
          this.restart();
        },

        touchStart: function (e) {
          this._x = e.changedTouches[0].clientX;
        },

        touchEnd: function (e) {
          if (!this.slider) return;
          var dx = e.changedTouches[0].clientX - this._x;
          if (Math.abs(dx) < 40) return;
          if (dx < 0) this.next();
          else this.prev();
          this.restart();
        }
      };
    });

    /* ===== Tooltip modal ===== */
    Alpine.data('toolTip', function () {
      return {
        open: false,
        context: '',
        _release: null,

        show: function (detail) {
          var self = this;
          if (!detail) return;
          this.$refs.content.innerHTML = detail.content || '';
          this.context = detail.context || '';
          if (!this.open) lockScroll(true);
          this.open = true;
          this._release = trapFocus(this.$root);
          this.$nextTick(function () { self.$refs.close.focus(); });
        },

        close: function () {
          this.$refs.content.innerHTML = '';
          if (this.open) lockScroll(false);
          this.open = false;
          this.context = '';
          if (this._release) this._release();
          this._release = null;
        }
      };
    });

    /* ===== Video modal (snippets/video-modal.liquid) ===== */
    Alpine.data('videoModal', function () {
      function youtubeId(url) {
        var match = url.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/);
        return match && match[7].length === 11 ? match[7] : false;
      }

      function iframe(src) {
        var f = document.createElement('iframe');
        f.src = src;
        f.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('frameborder', '0');
        return f;
      }

      return {
        open: false,

        init: function () {
          var self = this;
          document.addEventListener('click', function (e) {
            if (!e.target.closest) return;

            var yt = e.target.closest('a[href*="youtube.com/watch"], a[href*="youtu.be/"]');
            if (yt) {
              var id = youtubeId(yt.getAttribute('href'));
              if (!id) return;
              e.preventDefault();
              self.play(iframe('https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0'));
              return;
            }

            var vimeo = e.target.closest('a[href*="vimeo.com/"][data-video-id]');
            if (vimeo) {
              e.preventDefault();
              var loop = vimeo.dataset.videoLoop === 'true' ? '&loop=1' : '';
              self.play(iframe('https://player.vimeo.com/video/' + encodeURIComponent(vimeo.dataset.videoId) + '?autoplay=1' + loop));
              return;
            }

            var mp4 = e.target.closest('.product-video-trigger--mp4');
            if (mp4) {
              var player = mp4.parentNode.querySelector('.product-video-mp4-sound');
              if (!player) return;
              e.preventDefault();
              var clone = player.cloneNode(true);
              clone.classList.remove('hide', 'hidden');
              self.play(clone);
              var video = clone.tagName === 'VIDEO' ? clone : clone.querySelector('video');
              if (video) video.play();
            }
          });
        },

        play: function (node) {
          var self = this;
          this.$refs.holder.innerHTML = '';
          this.$refs.holder.appendChild(node);
          if (!this.open) lockScroll(true);
          this.open = true;
          this.$nextTick(function () { self.$refs.close.focus(); });
        },

        close: function () {
          if (!this.open) return;
          this.open = false;
          lockScroll(false);
          this.$refs.holder.innerHTML = '';
        }
      };
    });
  });
})();
